export default "__VITE_ASSET__DSooEz$U__"